import type { CommandRelation, Force, Level } from "./api/types";
import { k } from "./i18n/i18n";

/** Niveau Compagnie / Escadron (docs/21) : libellés propres au niveau, partagés par les Données initiales, la carte,
 *  la composition et l'aide. Le serveur dit la famille du S/GTIA (`family`, `unit_label`) ; le client n'applique
 *  aucune règle d'arme à lui. */

export const COMPANY: Level = "COMPAGNIE";

export const isCompany = (level: string | null | undefined): boolean => level === COMPANY;

/** Mission proposée par défaut à un nouveau dossier de compagnie (docs/21 §5, `company.DEFAULT_MISSION`). */
export const COMPANY_DEFAULT_MISSION = "S'emparer de";

/** Carte du niveau dans les Données initiales : « Compagnie » (sections) ou « Escadron » (pelotons) une fois le
 *  S/GTIA choisi, selon son arme (décision 1) ; les deux avant. Clés de traduction (`t` à l'affichage). */
export function companyCard(force: Pick<Force, "family" | "unit_label"> | null | undefined): { label: string; hint: string } {
  if (!force?.unit_label) return { label: k("Compagnie / Escadron"), hint: k("OPO du S/GTIA aux sections ou pelotons") };
  return force.family === "ARMOR"
    ? { label: k("Escadron"), hint: k("OPO du S/GTIA aux pelotons") }
    : { label: k("Compagnie"), hint: k("OPO du S/GTIA aux sections") };
}

/** Subordonnés du S/GTIA : « sections » (infanterie) ou « pelotons » (blindé). Clé de traduction. */
export function subordinatesNoun(family: string | null | undefined, plural = true): string {
  if (family === "ARMOR") return plural ? k("pelotons") : k("peloton");
  return plural ? k("sections") : k("section");
}

/** Relations de commandement d'une unité reçue en renforcement (décision 5), TACON par défaut. */
export const COMMAND_RELATIONS: readonly CommandRelation[] = ["TACON", "OPCON"];
export const DEFAULT_COMMAND: CommandRelation = "TACON";

/** Libellé et explication de chaque relation (définitions publiques de l'OTAN, AAP-6 ; sigles identiques en anglais).
 *  Clés de traduction. */
export const COMMAND_LABELS: Record<CommandRelation, { label: string; hint: string }> = {
  TACON: {
    label: "TACON",
    hint: k("Contrôle tactique : le S/GTIA dirige les mouvements et manœuvres de l'unité nécessaires à la mission reçue."),
  },
  OPCON: {
    label: "OPCON",
    hint: k("Contrôle opérationnel : le S/GTIA peut confier à l'unité des missions ou des tâches et la déployer, sans en séparer les éléments."),
  },
};
